import axios from 'axios'

let headers = {
    // 'Access-Control-Allow-Credentials': 'true',
    // 'Access-Control-Allow-Headers': 'Access-Control-Allow-Origin, Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers',
    // 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
    // 'Access-Control-Allow-Origin': '*',
    // 'Access-Control-Allow-Origin': true,
    'Content-Type': 'application/json',
};

/**
 * Wartość tokena z localStorage
 * @type {string}
 */
const token = localStorage.getItem('token');
if (token)
    headers['token'] = token;

/**
 * Wybór wybranego serwisu
 */
const domain = localStorage.getItem('domain_selected_id');
if (domain)
    headers['Domain-id'] = domain;

let baseURL = 'https://app.mcee.ciezkowice.pl/';
baseURL = 'https://app.strefaportali.pl/';

export default axios.create({
    // baseURL: 'https://sbg.strefaportali.pl/app/api.php/',
    baseURL: baseURL,
    crossDomain: true,
    mode: 'no-cors',
    headers: headers
})
